__turbopack_context__.v({
  "footer": "FooterMobile-module-scss-module__xoKwXW__footer",
  "newsletterSection": "FooterMobile-module-scss-module__xoKwXW__newsletterSection",
});
